import { api } from '@/lib/api';
import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';

export interface DoctorPatientPayload {
  doctor_id: number;
  user_id: number;
}

export const assignDoctorPatientMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.doctorPatients.assign(),
    mutationFn: async (payload: DoctorPatientPayload) => {
      return await api
        .post('admin/doctor-patients', {
          json: payload,
        })
        .json<void>();
    },
    onSuccess: () => {
      toast.success('Relation assigned successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to assign relation');
    },
  });
};

export const unassignDoctorPatientMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.doctorPatients.unassign(),
    mutationFn: async (payload: DoctorPatientPayload) => {
      // Assuming unassign also takes doctor_id and user_id in body
      return await api
        .delete('admin/doctor-patients', {
          json: payload,
        })
        .json<void>();
    },
    onSuccess: () => {
      toast.success('Relation unassigned successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to unassign relation');
    },
  });
};
